import { render, staticRenderFns } from "./UserAccess.vue?vue&type=template&id=46f206f4&lang=pug"
import script from "./UserAccess.vue?vue&type=script&lang=js"
export * from "./UserAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports